/* === Universal Add-to-Cart + Cart Drawer refresh (Dawn-compatible) === */
(() => {
  const ADD_ENDPOINT = "/cart/add.js";
  const SECTION_URL = `${location.pathname}?sections=cart-drawer,cart-icon-bubble`;

  function getProductForm(clickedEl) {
    return (
      clickedEl.closest('form[action*="/cart/add"]') ||
      clickedEl.closest('form.shopify-product-form') ||
      document.querySelector('form[action*="/cart/add"], form.shopify-product-form')
    );
  }

  async function addToCartFromForm(form) {
    const fd = new FormData(form);

    // Ensure a variant id is present
    if (!fd.get("id")) {
      const vid = form.querySelector('[name="id"][value]')?.value
        || document.querySelector('[name="id"][value]')?.value;
      if (vid) fd.set("id", vid);
    }

    // Default quantity = 1 if not present
    if (!fd.get("quantity")) fd.set("quantity", "1");

    // POST to Shopify cart API
    const res = await fetch(ADD_ENDPOINT, {
      method: "POST",
      headers: { Accept: "application/json" },
      body: fd
    });

    if (!res.ok) {
      // Surface error (e.g., invalid variant)
      const err = await res.json().catch(() => ({}));
      console.warn("ATC error:", err);
      throw new Error(err?.description || "Add to cart failed");
    }
  }

  async function refreshDrawer() {
    const res = await fetch(SECTION_URL, { headers: { "X-Requested-With": "XMLHttpRequest" } });
    const sections = await res.json();

    // Update the drawer HTML
    const drawerEl = document.querySelector("cart-drawer");
    if (drawerEl && sections["cart-drawer"]) {
      drawerEl.innerHTML = sections["cart-drawer"];
      drawerEl.classList.add("is-open");
      document.body.classList.add("overflow-hidden");
    }

    // Update the cart bubble/count
    const bubbleSel = "#cart-icon-bubble";
    const tmp = document.createElement("div");
    if (sections["cart-icon-bubble"]) {
      tmp.innerHTML = sections["cart-icon-bubble"];
      const newBubble = tmp.querySelector(bubbleSel);
      const oldBubble = document.querySelector(bubbleSel);
      if (newBubble && oldBubble) oldBubble.replaceWith(newBubble);
    }
  }

  // Intercept any clicks on ATC-like buttons
  document.addEventListener("click", async (e) => {
    const btn = e.target.closest(
      'button[name="add"], .product-form__submit, [data-atc], .js-atc'
    );
    if (!btn) return;

    const form = getProductForm(btn);
    if (!form) return;

    e.preventDefault();
    btn.disabled = true;

    try {
      await addToCartFromForm(form);
      await refreshDrawer();
    } catch (err) {
      console.error(err);
      // Fallback: go to /cart so user isn’t stuck
      location.href = "/cart";
    } finally {
      btn.disabled = false;
    }
  });

  // Also catch direct form submits (keyboard, etc.)
  document.addEventListener("submit", async (e) => {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"], form.shopify-product-form')) return;
    e.preventDefault();
    try {
      await addToCartFromForm(form);
      await refreshDrawer();
    } catch (err) {
      console.error(err);
      location.href = "/cart";
    }
  });
})();
